export default __webpack_public_path__ + "static/t7-1868d9e4944c12046a8be3203d44e12e.webp";